// extracted by mini-css-extract-plugin
export default {"container":"About_container__pxvGf","header":"About_header__P2f9o","main":"About_main__Mjr12"};